import { LOTTIE_VISUAL } from '../elements/lottie'
import { CONVERSATION_BOX } from '../elements/conversationBox'
import { IMAGE_DESKTOP, IMAGE_MOBILE, BACKGROUND_IMAGE, ASSET, ICON_FIELD } from '../elements/assets'

const INFORMATION_ACCORDION_CONTENT = `
informationAccordionContent {
  ... on informationAccordionContent_Entry {
    accordion {
      ... on accordionItemImage_Entry {
          ${ LOTTIE_VISUAL }
  ${ CONVERSATION_BOX }
        id
        heading
        description {
          html
        }
        
        ${ IMAGE_DESKTOP }
        ${ IMAGE_MOBILE }
      }
    }
  }
}
`

export const INFORMATION_ACCORDION = `
...on informationAccordion_Entry {
  id
  typeHandle
  heading {
    html
  }
  description

  ${ INFORMATION_ACCORDION_CONTENT }
}
`

export const ACCORDION_MEDIA = `
...on accordionMedia_Entry {
  id
  typeHandle
  
  heading {
    html
  }
  description
  
  accordionMediaContent {
    ... on accordionMediaContent_Entry {
      accordionMediaTabs {
        ... on accordionMediaItem_Entry {
          title
          id
          ${ BACKGROUND_IMAGE }
          ${ ICON_FIELD }
          ${ ASSET }
        }
      }
      
    }
  }
}
`

export const INFORMATION_ACCORDION_DELIGHT = `
...on informationAccordionDelight_Entry {
  id
  typeHandle
  
  heading {
    html
  }
  description
  positionInformationAccordion

  informationAccordionContent {
    ... on informationAccordionContent_Entry {
      accordion {
        __typename

        ... on accordionItemImageList_Entry {
          ${ LOTTIE_VISUAL }
  ${ CONVERSATION_BOX }
          id
          heading
          iconTextMatrix {
            ... on iconText_Entry {
              id
              title
              iconField {
                url
              }
            }
          }
          
          ${ IMAGE_DESKTOP }
          ${ IMAGE_MOBILE }
        }

        ... on accordionItemImage_Entry {
          ${ LOTTIE_VISUAL }
  ${ CONVERSATION_BOX }
          id
          heading
          label
          description {
            html
          }
          
          ${ IMAGE_DESKTOP }
          ${ IMAGE_MOBILE }
        }
      }
    }
  }
}
`